import { WebhookHistory } from 'types';

import { createCrudApi } from './crud.api';

export const webhooksApi = createCrudApi<WebhookHistory>('/webhooks');
